module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "part1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "booktitle",
    staticStyle: {
      "margin-bottom": "1em!important"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/05_toc#pt1"
    }
  }, [_c('big', [_c('em', [_vm._v("Prince de Neufchatel")])])], 1)]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "booksubtitle",
    staticStyle: {
      "margin-top": "5em!important"
    },
    attrs: {
      "id": "pt1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/05_toc#pt1"
    }
  }, [_vm._v("Building the Privateer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/fm-2.jpg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02d1b586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/07_part1.vue
// module id = 75
// module chunks = 0